<template>
  <div v-if="show" class="overlay" @click.stop="">
    <div class="overlay_inner channel_list scrollable_popup">
      <p class="note"><slot name="title"></slot></p>
      <div class="scrollable_popup">
        <slot name="body"></slot>
      </div>
      <a @click.stop="showModal(false)" class="btn btn_action btn_close" :title="$gettext('Zavřít')" v-translate>Zavřít</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  data: function (){
    return {
      show: false,
    }
  },
  methods:{
    showModal(value){
      this.show = value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/Modal.vue